import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

const BEM_BLOCK: string = 'sc-app';

@Component({
    selector: 'sc-app',
    template: '<router-outlet />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet],
    host: {
        class: BEM_BLOCK,
    },
})
export class AppComponent {}
